import React from 'react';
import clsx from 'clsx';
import AddingBlocksToNewPage from './AddingBlocksToNewPage';
import DuplicateListItem from "./DuplicateListItem";
import AddingImage from "./AddingImage";
import CreateNewPage from './CreateNewPage';
import { TitleImage } from "../AboutPageGeneralComp";

/**
 *  This component renders the steps of second section of example 'design a page' in 
 *  markdown body.  
 */
const DesignPageSection2 = ({elSubRefs}) => (
    <>
        <InsertListItems elSubRefs={elSubRefs} />
        <DuplicateListItem elSubRefs={elSubRefs} />
        <AddingImage elSubRefs={elSubRefs} />   
        <EditingListItems elSubRefs={elSubRefs} />
        <CreateNewPage elSubRefs={elSubRefs} />    
        <AddingBlocksToNewPage elSubRefs={elSubRefs} />
    </>
)

//  This component renders insert list items
const InsertListItems = ({elSubRefs}) => (
    <div id="Group8Sub6" ref ={elSubRefs[5]} className={clsx("subgroup")}>
        <h4 id="Group8Sub6">Insert a List Items</h4>
        <TitleImage 
            title='Drag and Drop a "List Items" block.'
            srcImg= '/images/AboutPageMarkdownImg/12.jpg'
        />
    </div> 
)

//  This component renders edit list items
const EditingListItems = ({elSubRefs}) => (
    <div id="Group8Sub9" ref ={elSubRefs[8]} className={clsx("subgroup")}>
        <h4 id="Group8Sub9">Editing a List Items</h4>
        <TitleImage
            title='You can now edit the text of your "List Items" block.'
            srcImg= '/images/AboutPageMarkdownImg/17.jpg'
        />
    </div> 
)


export default DesignPageSection2